import { ResponsiveContainer, AreaChart, Area, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { money } from "@/lib/api";

const axis = { stroke: "#64748b", fontSize: 11, fontFamily: "JetBrains Mono" };
const tip = { contentStyle: { background: "#0f172a", border: "1px solid #334155", borderRadius: 8 }, labelStyle: { color: "#f8fafc" } };

export const ProjectionChart = ({ data = [], currency }) => (
  <div className="h-64 print-avoid" data-testid="financial-projection-chart">
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data}>
        <CartesianGrid stroke="#1e293b" vertical={false} />
        <XAxis dataKey="year" {...axis} />
        <YAxis {...axis} tickFormatter={(v) => money(v, currency)} width={80} />
        <Tooltip {...tip} formatter={(v) => money(v, currency)} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar dataKey="revenue" fill="#10b981" radius={[4, 4, 0, 0]} />
        <Bar dataKey="costs" fill="#f43f5e" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export const ScoreBars = ({ data = [] }) => (
  <div className="space-y-3 print-avoid" data-testid="site-score-bars">
    {data.map((d, i) => {
      const s = Math.max(0, Math.min(10, Number(d.score) || 0));
      const color = s >= 7 ? "bg-emerald-500" : s >= 5 ? "bg-amber-500" : "bg-rose-500";
      return (
        <div key={i} className="grid grid-cols-12 items-center gap-3 text-sm">
          <span className="col-span-4 md:col-span-3 text-slate-300 truncate">{d.factor}</span>
          <div className="col-span-6 md:col-span-8 h-2.5 rounded-full bg-slate-800 overflow-hidden"><div className={`h-full ${color} rounded-full`} style={{ width: `${s * 10}%` }} /></div>
          <span className="col-span-2 md:col-span-1 num text-right font-bold">{s}</span>
        </div>
      );
    })}
  </div>
);

export const GrowthChart = ({ data = [], currency }) => (
  <div className="h-56 print-avoid" data-testid="market-growth-chart">
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data}>
        <defs>
          <linearGradient id="g" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#06b6d4" stopOpacity={0.5} /><stop offset="100%" stopColor="#06b6d4" stopOpacity={0} /></linearGradient>
        </defs>
        <CartesianGrid stroke="#1e293b" vertical={false} />
        <XAxis dataKey="year" {...axis} />
        <YAxis {...axis} tickFormatter={(v) => money(v, currency)} width={80} />
        <Tooltip {...tip} formatter={(v) => money(v, currency)} />
        <Area dataKey="value" stroke="#06b6d4" fill="url(#g)" strokeWidth={2} />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);
